
































































import Vue from "vue"
import { required, email } from "vuelidate/lib/validators"
import ConversionButton from "~/components/guideline/button/ConversionButton.vue"
import FormInputField from "~/components/guideline/form/field/InputField.vue"
import FormWrapper from "~/components/guideline/form/FormWrapper.vue"
import Modal from "~/components/guideline/modal/SimpleModal.vue"

export default Vue.extend({
  components: {
    ConversionButton,
    FormInputField,
    FormWrapper,
    Modal,
  },
  data() {
    return {
      email: "",
      isLoading: false,
      errorMessage: "",
      finishedSendMail: false,
    }
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  computed: {
    emailError() {
      if (this.$v.email.$error) {
        if (!this.$v.email.required) {
          return "メールアドレスは必須項目です。"
        }
        if (!this.$v.email.email) {
          return "メールアドレスの形式が不正です。"
        }
      }
      return ""
    },
  },
  methods: {
    async sendResetMail() {
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.isLoading = true
      await this.$clAuth.sendPasswordResetEmail(this.email).catch(() => {
        // エラーが発生しても何もしない。
        // 未登録メールアドレスの場合にエラーメッセージを返してしまうと、登録されているメールアドレスを確認することができてしまう。
        // 悪用を防ぐため、エラーがあっても画面上はそのまま処理する。
        // Rollbarに通知が飛ばないように、キャッチして握りつぶす。
      })
      this.finishedSendMail = true
    },
    goLogin() {
      this.$nuxt.$router.push("/login")
    },
  },
})
